module.exports = ".mat-dialog-content {\n  max-height: none !important;\n  background-color: red; }\n"